import { render } from "./NavigationPrimary.vue?vue&type=template&id=f85912f8&scoped=true"
import script from "./NavigationPrimary.vue?vue&type=script&lang=js"
export * from "./NavigationPrimary.vue?vue&type=script&lang=js"

import "./NavigationPrimary.vue?vue&type=style&index=0&id=f85912f8&scoped=true&lang=css"

import exportComponent from "/home/runner/work/vizbi-frontend-test/vizbi-frontend-test/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f85912f8"]])

export default __exports__